"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ClickDropDownComponent = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _ClickDropDown = _interopRequireDefault(require("./ClickDropDown.render"));
/**
 * Nav item dropdown click drop down functionality
 */
class ClickDropDownComponent extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.onNavItemSelected = () => this.props.setClickedItem(this.props.menuItemId);
    this.onNavItemDeselected = () => this.props.setClickedItem(null);
    this.onKeyboardSelect = event => {
      const key = event.key || event.keyCode;
      const selectKeys = ['Enter', 13, 'Space', 'Spacebar', 32, ' '];
      if (selectKeys.some(x => x === key)) {
        this.onNavItemSelected();
      }
    };
    this.handleButtonClick = () => {
      if (this.props.selected) {
        this.onNavItemDeselected();
      } else {
        this.onNavItemSelected();
      }
    };
    this.handleButtonFocus = () => {
      // deselect previous drop down
      this.props.onMouseLeave();
      window.addEventListener('keyup', this.onKeyboardSelect);
    };
    this.handleButtonBlur = () => {
      window.removeEventListener('keyup', this.onKeyboardSelect);
    };
    this.handleClose = () => {
      this.onNavItemDeselected();
    };
  }
  handleClickOutside() {
    if (this.props.selected) {
      this.onNavItemDeselected();
    }
  }
  render() {
    return (
      /*#__PURE__*/
      // @ts-ignore
      React.createElement(_ClickDropDown.default, Object.assign({}, this.props, {
        onClick: this.handleButtonClick,
        onFocus: this.handleButtonFocus,
        onBlur: this.handleButtonBlur,
        onClose: this.handleClose
        // @ts-ignore
        ,
        onNavItemSelected: this.onNavItemSelected,
        onNavItemDeselected: this.onNavItemDeselected
      }), this.props.children)
    );
  }
}
exports.ClickDropDownComponent = ClickDropDownComponent;
var _default = exports.default = (0, _reactClickOutside.default)(ClickDropDownComponent);